// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"38831d19","221":"988aedec","237":"b3df3c56","298":"dd6514be","453":"e4e7e3c9","471":"8c9cb578","496":"10a860e2","759":"1de993a2","887":"e3badb4a","950":"fdfa44eb"}[chunkId] + ".chunk.js";
};